import List from "@mui/material/List";
import { ListItem } from "@mui/material";
import Typography from "@mui/material/Typography";
import { formatCurrency } from "../../utils";
import { Trans, useTranslation } from "react-i18next";
import QuantitySelector from "./QuantitySelector";
import Divider from "@mui/material/Divider";
import React, { useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { callAPI } from "../../lib/common";
import { useWebshopApiClient } from "@/react/Webshop/providers/WebshopApiClientProvider";

const useStyles = makeStyles((theme) => ({
  primaryText: {
    fontWeight: "bold",
    fontSize: "20px",
  },
  secondaryText: {
    fontSize: "15px",
  },
  itemRoot: {
    alignItems: "stretch",
    flexDirection: "column",
  },
  listItem: {
    marginBottom: theme.spacing(2),
    maxWidth: "100%",
  },
  listItemInfo: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
  },
  descriptionContainer: {
    width: "100%",
  },
  description: {
    display: "box",
    fontSize: "12px",
    marginBottom: 0,
    textOverflow: "ellipsis",
    lineClamp: 3,
    boxOrient: "vertical",
    overflow: "hidden",
    "&.expanded": {
      lineClamp: "unset",
    },
  },
  deliveryTime: {
    fontSize: "12px",
  },
  quantity: {
    display: "flex",
    fontSize: "12px",
    alignItems: "center",
    justifyContent: "flex-end",
    flexDirection: "column",
    // A long catalogue name or description must not squeeze the selector.
    flexShrink: 0,
  },
}));

const BuyCatalogueList = ({ catalogues, handleChange }) => {
  const classes = useStyles();

  return (
    <List>
      {catalogues.map((catalogue, index) => {
        return (
          <>
            <ListItem
              disableGutters
              classes={{ root: classes.itemRoot }}
              key={`${catalogue.uuid}-${catalogue.subject.uuid}`}
            >
              <CatalogueItem
                catalogue={catalogue}
                handleChange={handleChange}
              />
            </ListItem>
            {index != catalogues.length - 1 && <Divider />}
          </>
        );
      })}
    </List>
  );
};

const CatalogueItem = ({ catalogue, handleChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [descriptionExpanded, setDescriptionExpanded] = useState(false);
  return (
    <div className={classes.listItem}>
      <div className={classes.listItemInfo}>
        <div>
          <div className={classes.primaryText}>{catalogue.name}</div>
          <div className={classes.secondaryText}>
            {catalogue.subject.group}: {catalogue.subject.name}
          </div>
          <Typography variant="body">
            {t("%s each", {
              postProcess: "sprintf",
              sprintf: [formatCurrency(catalogue.price)],
            })}
          </Typography>
          <div className={classes.deliveryTime}>
            <Trans>
              Shipped separately, normally within{" "}
              {{ days: catalogue.deliveryTime.days }} days after the last photo
              day.
            </Trans>
          </div>
          <div className={classes.descriptionContainer}>
            <p
              className={`${classes.description} ${
                descriptionExpanded ? "expanded" : ""
              }`}
              onClick={() => setDescriptionExpanded(!descriptionExpanded)}
            >
              {catalogue.description.split(/\n/).map((line) => (
                <>
                  {line}
                  <br />
                </>
              ))}
            </p>
          </div>
        </div>
        <div className={classes.quantity}>
          <div>
            <Trans>Quantity</Trans>
          </div>
          <div>
            <QuantitySelector
              includeZero={true}
              quantity={catalogue.quantity || 0}
              maxQuantity={catalogue.maxQuantity || 10}
              onChange={handleChange(catalogue)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const useBuyCatalogueList = () => {
  const [catalogues, setCatalogues] = useState([]);
  const webshopApiClient = useWebshopApiClient();

  useEffect(() => {
    webshopApiClient.getCatalogues().then((catalogues) => {
      // If only one catalogue, set qty to 1:
      if (catalogues.length === 1) {
        catalogues[0].quantity = 1;
      }
      setCatalogues(catalogues);
    });
  }, []);

  const handleChange = (cat) => (e) => {
    const newQuantity = parseInt(e.target.value);
    setCatalogues((catalogues) => {
      return catalogues.map((catalogue) => {
        console.log("Sett new qty? ", cat, catalogue);
        if (
          catalogue.uuid == cat.uuid &&
          catalogue.subject.uuid == cat.subject.uuid
        ) {
          console.log("Setting new quantity", newQuantity, catalogue);
          return {
            ...catalogue,
            quantity: newQuantity,
          };
        } else {
          return catalogue;
        }
      });
    });
    console.log("The event is ", e.target.value);
  };

  return { catalogues, handleChange };
};

export default BuyCatalogueList;
